<template>
  <div class="contain page3-con" id="Mobile3">
    <div class="head-data">
      <div class="el-container myMain">
        <h3>验收审定数据：</h3>
        <section>
          <div class="li-con" v-for="(item, index) in validData" :key="index">
            <countTo
              :startVal="0"
              :endVal="item.num"
              :duration="3000"
            ></countTo><span class="little-font">{{ item.suffix }}</span>
            <div class="name little-font">{{ item.name }}</div>
          </div>
        </section>
      </div>
    </div>
    <div class="con">
      <div class="con-head title-box">
        <div class="title-chinese">
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
          <h3><router-link to="/footPath" class="h3-a">场地步道</router-link></h3>
          <div>
            <p class="line"></p>
            <p class="line"></p>
          </div>
        </div>
        <div class="title-english">
          <p class="about" style="color: #666">FIELDS & TRAILS</p>
        </div>
        <router-link to="/footPath" class="footpath-link">点击查看更多</router-link>
        <el-row>
          <el-select
            placeholder="切换场地"
            class="map-view-select"
            v-model="selectField"
            @change="selectFieldChange"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-row>      
      </div>
    </div>
    <div class="distribution">
      <ul>
        <li class="info-left hidden-sm-and-down">
        <template v-if="tops.length">
          <div class="fieldInfo" v-for="top in tops.slice(0, 2)" :key="top.id">
            <h4><router-link :to="`/footPath?search=${top.site_name}&type=${selectField}`">{{ top.site_name }}</router-link></h4>
            <div class="lineBox">
              <i class="circular"></i>
              <i class="line"></i>
            </div>

            <p>
              {{ top.introduction }}
            </p>
          </div>
        </template>
        </li>
        <li class="info-img">
          <map-img ref="mapEle" @changeMapSel="changeMapSel" @clickMapSel="clickMapSel"></map-img>
        </li>
        <li class="info-right hidden-sm-and-down">
        <template v-if="tops.length>2">
          <div class="fieldInfo" v-for="top in tops.slice(2, 4)" :key="top.id">
            <h4><router-link :to="`/footPath?search=${top.site_name}&type=${selectField}`">{{ top.site_name }}</router-link></h4>
            <div class="lineBox">
              <i class="circular"></i>
              <i class="line"></i>
            </div>

            <p>
              {{ top.introduction }}
            </p>
          </div>
        </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import { getAlameda, getAuthData, getMapData } from "@/api/home/index";
import mapImg from "./map.vue";

export default {
  components: { countTo, mapImg },
  data() {
    return {
      selectField: 0,
      validData: [
        {
          name: "遍布城市",
          num: 385,
          id: 'cityCount',
          suffix:'余个',
        },
        {
          name: "场地验收",
          num: 4167,
          id: 'siteCount',
          suffix:'块',
        },
        {
          name: "面层产品",
          num: 94,
          id: 'surfaceCount',
          suffix:'类',
        },
        {
          name: "器材审定",
          num: 208,
          id: 'equipmentCount',
          suffix:'项',
        },
        {
          name: "计时芯片审定",
          num: 16,
          id: 'socCount',
          suffix:'企业',
        },
      ],
      options: [
        {
          label: "场地",
          value: 0,
        },
        {
          label: "步道",
          value: 1,
        },
      ],
      alamedaData: [],
      authData: null,
      mapData: [],
      tops: []
    };
  },
  created() {
    getAlameda({ show: 0 }).then((res) => {
      this.alamedaData = res.data;
    });
    this.getAuth();
    this.getMap();
  },
  methods: {
    selectFieldChange(val){
      this.getMap();
    },
    changeMapSel(index){
      this.tops = this.mapData[index] ? this.mapData[index].top4 : [];
    },
    clickMapSel(index){
      let province = this.mapData[index].province;
      //两个页面的地图数据直辖市表示不同，丑陋地手动改一下
      if(['北京','天津', '重庆', '上海'].includes(province)){
        province = province + '市';
      }
      this.$router.push(`/footPath?province=${province}&type=${this.selectField}`);
    },
    getAuth(success){
      // getAuthData().then((res) => {
      //   this.authData = res.data;
      //   success && success();
      // });
    },
    getMap(){
      const type = this.selectField;
      getMapData({ type }).then(res=>{

        const data = res.data;
        this.mapData = data;
        this.tops = data[0] && data[0].top4 ? data[0].top4 : [];
        this.$refs.mapEle.setData(data, type);
      })
    },
    setCountTo() {
      const _this = this;
      const setCount = ()=>{
          _this.validData.forEach((item, index)=>{
            _this.$set(item, "num", _this.authData[item.id]);
          })
      }
      if(!this.authData){
        //this.getAuth(setCount)
      }else{
        setCount()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.page3-con {
  height: 100%;
  background: #fff;
  .head-data {
    width: 100%;
    height: 290px;
    padding-top: 2%;
    // padding-left: 8%;
    background: url("../../../assets/image/home/screen3.jpg");
    background-size: 100% 100%;
    box-sizing: border-box;
    .el-container {
      display: flex;
      flex-direction: column;
    }
    section {
      width: 100%;
      display: flex;
      justify-content: space-around;
    }
    h3 {
      font-size: 32px;
      text-align: left;
      margin-bottom: 30px;
    }
    section div.li-con {
      width: 20%;
      // font-size: 46px;
      span:first-child{
        font-family: FZZJ-HLYHXSJW, FZZJ;
        font-weight: normal;
        font-size: 46px;
      }
      .name {
        // display: block;
        margin-top: 20px;
      }
      .little-font {
        font-size: 20px;
      }
    }
  }
  .con {
    padding-top: 24px;
    box-sizing: border-box;
    .con-head .el-row {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .el-col-6 {
        width: 10%;
      }
      .el-col {
        h3 {
          font-size: 38px;
          color: #da5351;
        }
        .line {
          width: 85px;
          height: 2px;
          background-color: #d8d8d8;
        }
        .line:last-child {
          margin-top: 2px;
        }
      }
      p.about {
        font-size: 18px;
        margin-top: 16px;
        margin-bottom: 26px;
      }
    }
  }
  .distribution {
    width: 100%;
    padding-top: 30px;
    ul {
      display: flex;
      justify-content: center;
      .fieldInfo {
        display: flex;
        flex-direction: column;

        a{
          text-decoration: none;
          color: inherit;
        }
      }
      .line {
        margin: 16px 0;
      }
      .lineBox {
        display: flex;
        justify-content: center;
        align-items: center;
        .circular {
          display: inline-block;
          width: 10px;
          height: 10px;
          background: #da5351;
          border-radius: 50%;
        }
      }
      .info-left {
        width: 268px;
        padding-right: 34px;
        .fieldInfo {
          &:nth-child(1) {
            margin-top: 70px;
            margin-bottom: 93px;
          }
          h4 {
            text-align: left;
            font-size: 24px;
            color: #222222;
          }
          .lineBox {
            flex-direction: row-reverse;
            .line {
              display: inline-block;
              width: 100%;
              border: 1px dashed #dddddd;
            }
          }

          p {
            font-size: 14px;
            color: #666666;
          }
        }
      }
      .info-img {
        width: 607px;
        height: 467px;
        div {
          width: 100%;
          height: 100%;
          canvas {
            width: 100%;
            height: 100%;
          }
        }
        // padding: 0 28px;
      }
      .info-right {
        width: 268px;
        padding-left: 34px;
        .fieldInfo {
          &:nth-child(1) {
            margin-top: 70px;
            margin-bottom: 93px;
          }
          h4 {
            text-align: right;
            font-size: 24px;
            color: #222222;
          }
          .line {
            display: inline-block;
            width: 100%;
            border: 1px dashed #dddddd;
          }
          p {
            font-size: 14px;
            color: #666666;
          }
        }
      }
    }
  }
  .map-view-select {
    font-size: 18px;
    color: #666666;
    line-height: 25px;
    border-radius: 30px;
    border: 1px solid #dddddd;
    width: 146px;
    height: 46px;
    line-height: 46px;
    padding: 0 15px;
    box-sizing: border-box;
    ::v-deep {
      .el-input {
        .el-input__inner {
          border: none !important;
        }
      }
      .el-input__suffix {
        right: 0;
        .el-select__caret {
          // color: #000;
        }
      }
    }
  }
  .con-head.title-box .title-english .about{
    margin-bottom: 10px;
  }
  .footpath-link{
    color: #666666;
    text-decoration: none;
    margin-bottom: 14px;
    display: inline-block;
    cursor: pointer;
  }
}
// 移动端
@media screen and (max-width: 960px) {
  #Mobile3 {
    padding-bottom: 0.24rem;
    .head-data {
      background: url("../../../assets/image/home/mobile/m-screen3.jpg");
      background-size: cover;
      height: 1.48rem;
      padding: 0;
      .el-container {
        width: 100%;
        height: 100%;
        h3 {
          padding: 0.12rem 0 0 0.24rem;
          font-size: 0.14rem;
          line-height: 0.2rem;
          margin-bottom: 0.12rem;
        }
        section {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .li-con {
            width: 33.33%;
            &:nth-child(4),
            &:nth-child(5) {
              margin-top: 0.14rem;
              width: 40%;
            }
            &:nth-child(4) {
              margin-left: 10%;
            }
            &:nth-child(5) {
              margin-right: 10%;
            }
            span:nth-child(1) {
              font-size: 0.18rem;
              line-height: 0.21rem;
              color: #ffffff;

              margin-top: 0;
            }
            .little-font{
              font-size: 0.12rem;
              line-height: 0.12rem;
            }
            .name {
              font-size: 0.12rem;
              line-height: 0.12rem;
              color: #ffffff;
              margin-top: 0.06rem;
              font-weight: 300;
            }
          }
        }
      }
    }
    .con {
      .title-box {
        display: flex;
        flex-direction: column;
      }
      .el-select {
        width: 1.03rem;
        height: 0.23rem;
        font-size: 0.09rem;
        margin-bottom: 0.12rem;
        .el-input {
          height: 100%;
        }
      }
      .about {
        margin-bottom: 0.12rem;
      }
      .map-view-select {
        line-height: .23rem;
        color: #666666;
        ::v-deep{
          .el-input__inner{
            font-size: .09rem;
            line-height: .21rem;
            height: .21rem;
            vertical-align: top;
          }
          .el-icon-arrow-up {
            width: 0.14rem;
            line-height: .21rem;
          }
          .el-input__suffix{
            height: .21rem;
            line-height: .21rem;
            display: flex;
            align-content: center;
            justify-content: center;
          }
         
        }
      }
      .footpath-link{
        margin-bottom: .14rem;
        font-size: .12rem;
      }

    }
    .distribution {
      padding-top: 0.12rem;
      // padding: 0 0.12rem;
      margin: 0;
      ul {
        .info-img {
          width: 2.73rem;
          height: 2.14rem;
          div {
            width: 100%;
            height: 100%;
          }
        }
        li {
          padding: 0 0.4rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
<!--
<style lang="scss">
// ele
@media screen and (max-width: 768px) {
  #Mobile3 {
    .el-input {
      width: 100%;
      height: 100%;
    }
    .el-input__inner {
      width: 100%;
      height: 100%;
      border-radius: 0.15rem;
      border: 1px solid #dddddd;
      font-size: 0.09rem;
      line-height: .2rem;
      padding: 0;
      color: #666666;
    }
    .el-input__suffix {
      // right: -26%;
      // top: 46%;
      // height: 100%;
      height: 0.14rem;
      display: flex;
      align-content: center;
      justify-content: center;
    }
    .el-icon-arrow-up {
      width: 0.14rem;
      height: 0.14rem;
    }
    .el-icon-arrow-up:before {
      position: absolute;
      right: 0;
      top: -0.16rem;
    }
  }
  .el-select {
    -webkit-tap-highlight-color: transparent !important;
  }
}
</style>-->
